// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// ASP #25 (D-CRX-82 §5) — the "Enrollment ref": a short, readable handle for a therapy that staff
// can say on the phone. DISPLAY ONLY. It is the first 10 hex digits of the therapy id, so it is not
// guaranteed unique and is never used to look anything up — a search on it returns every match.
// C# twin: functions/CareRx/TherapyRef.cs (the enrollment PDF header).

export const THERAPY_REF_LABEL = 'Enrollment ref'

export function therapyRef(therapyId: string | null | undefined): string | null {
  const hex = (therapyId ?? '').replace(/-/g, '')
  return /^[0-9a-f]{32}$/i.test(hex) ? `ENR-${hex.slice(0, 10).toUpperCase()}` : null
}
